module.exports = __webpack_public_path__ + "static/media/header-blue.48cfc2d6.jpg";